import i18n from '@/helper/i18n';

export default function formatVoucherStatusToShow(value) {
  return i18n.te(`vouchers.statusToShowOptions.${value}`)
    ? i18n.t(`vouchers.statusToShowOptions.${value}`)
    : value;
}
